<template>
    <div>
        <div class="row">
            <base-input
                v-model="payment.area_code"
                v-validate="'required'"
                v-mask="'###'"
                :name="$t('cart.recurrence.area_code')"
                :placeholder="$t('cart.recurrence.area_code')"
                :error="errors.first($t('cart.recurrence.area_code'))"
                type="text"
                class="col-12 col-md-2"
            ></base-input>
            <base-input
                v-model="payment.phone_number"
                v-validate="'required|regex:^[0-9]{9}$'"
                v-mask="'#########'"
                :name="$t('cart.recurrence.phone_number')"
                :placeholder="$t('cart.recurrence.phone_number')"
                :error="errors.first($t('cart.recurrence.phone_number'))"
                type="text"
                class="col-12 col-md-5"
            ></base-input>
            <base-input
                v-model="payment.birth"
                v-validate="'required|regex:^[0-9]{2}/[0-9]{2}/[0-9]{4}$'"
                :name="$t('cart.recurrence.birth')"
                :placeholder="$t('cart.recurrence.birth')"
                :error="errors.first($t('cart.recurrence.birth'))"
                v-mask="'##/##/####'"
                type="text"
                class="col-12 col-md-5"
            ></base-input>
        </div>
        <AddressForm v-model="payment.address" />
    </div>
</template>

<script>
    import Card from '../../argon/components/Cards/Card';
    import BaseInput from '../../argon/components/Inputs/BaseInput';
    import BaseButton from '../../argon/components/BaseButton';
    import AddressForm from "../FormBuilderComponents/ContentComponents/AddressForm";

    export default {
    emits: ['input', 'update:modelValue'],
        name: 'ChangePaymentForm',
        components: {
            Card,
            BaseInput,
            AddressForm,
            BaseButton
        },
        props: {
            modelValue: {
                type: Object,
                required: true
            },
            color: {
                type: Object,
                required: true
            }
        },
        computed: {
            payment: {
                get() {
                    return this.modelValue
                },
                set(value) {
                    this.$emit('update:modelValue', value);
                    this.$emit('input', value);
                }
            }
        }
    }
</script>
